import TNTControlBase from '../../util/TNTControlBase';

class CostCenterController extends TNTControlBase {
    /*@ngInject*/
    constructor($state) {
        super();
        this.acl = {}
        this.hasACL = {}
        this.id = 'cost_center'
        this.$state = $state

    }
    $onInit() {
        super.$onInit()
        for (let key in this.acl['tnt_control_' + this.id]) {
            this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
        }
    }
}

export default CostCenterController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/cost_center/cost_center.controller.js